var map = {
	"./": [
		39981,
		9
	],
	"./config": [
		88904,
		3
	],
	"./config.json": [
		88904,
		3
	],
	"./index": [
		39981,
		9
	],
	"./index.js": [
		39981,
		9
	]
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var ids = map[req], id = ids[0];
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 62619;
module.exports = webpackAsyncContext;